import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import GalleryBgStatic from "../../Assets/Svg/Gallery_Back_Stitc.svg";
import GalleryWaistCoat from "../../Product/School_Uniforms/waistcoat/MainGallery.jpg";
import GalleryVestsSchool from "../../Product/School_Uniforms/Vests/MainGallery.jpg";
import GalleryTrousersShorts from "../../Product/School_Uniforms/Trousers-Shorts/MainGallery.jpg";
import GallerySportsWear from "../../Product/School_Uniforms/Sports-Wear/MainGallery.jpg";
import GallerySkirtsSkorts from "../../Product/School_Uniforms/Skirts-Skorts/MainGallery.jpg";
import GalleryShirtsSchool from "../../Product/School_Uniforms/Shirts/MainGallery.jpg";
import GalleryPolosTShirts from "../../Product/School_Uniforms/Polos_T-Shirts/MainGallery.jpg";
import GalleryPinaFores from "../../Product/School_Uniforms/Pinafores/MainGallery.jpg";
import GalleryJumperSchool from "../../Product/School_Uniforms/Jumper/MainGallery.jpg";
import GalleryGraduationGown from "../../Product/School_Uniforms/Graduation-Gown/MainGallery.jpg";
import GalleryCardigansSchool from "../../Product/School_Uniforms/Cardigans/MainGallery.jpg";
import GalleryBlazersSchool from "../../Product/School_Uniforms/Blazers/MainGallery.jpg";
import GallleryHoodySweatShirt from "../../Product/Casual/Hoody_Sweatshirt/MainGallery.webp";
import GalleryJacketsVestCas from "../../Product/Casual/Jackets_Vest_Cas/MainGallery.webp";
import GalleryPoloCasual from "../../Product/Casual/Polo_Cas/MainGallery.webp";
import GalleryCapCasual from "../../Product/Casual/Cap_Cas/MainGallery.webp";
import GalleryVisibilitySuit from "../../Product/Industrial/Visibility_Suit/MainGallery.webp";
import GalleryVisibilityShirt from "../../Product/Industrial/Visibility_Shirt/MainGallery.webp";
import GalleryVisibilityJacket from "../../Product/Industrial/Visibility_Jacket/MainGallery.jpg";
import GalleryVisibilityHiVisBib from "../../Product/Industrial/Visibility_Hi_Vis_Bib/MainGallery.webp";
import GalleryVisibilityCoverall from "../../Product/Industrial/Visibility_Coverall/MainGallery.webp";
import GalleryIndustrialVest from "../../Product/Industrial/Vest/MainGallery.webp";
import GalleryFireRetardantCoverall from "../../Product/Industrial/Fire_Retardant_coverall/MainGallery.webp";
import GalleryCoverall from "../../Product/Industrial/Coverall/MainGallery.webp";
import GalleryAprons from "../../Product/Hospitality/Aprons/MainGallery.webp";
import GalleryChefCoat from "../../Product/Hospitality/Chef_Coat/MainGallery.webp";
import GalleryChefSuit from "../../Product/Hospitality/Chef_Suit/MainGallery.webp";
import GalleryChefHat from "../../Product/Hospitality/Chef_Hat/MainGallery.webp";
import GalleryOutfitSport from "../../Product/Sportswear/Outfit-Sport/MainGallery.webp";
import GalleryTopsBottomsSport from "../../Product/Sportswear/Tops&Bottoms-Sport/MainGallery.webp";
import GallerySuitsVestsCor from "../../Product/Corporate/Suits&Vests-Cor/MainGallery.webp";
import GallerySecurityCor from "../../Product/Corporate/Security-Cor/MainGallery.webp";
import GalleryBlouseFormalCor from "../../Product/Corporate/Blouse&Formal-Shirts-Cor/MainGallery.webp";
import GalleryDressesCor from "../../Product/Corporate/Dresses/MainGallery.webp";
import GallerySkirtsTrousersCor from "../../Product/Corporate/Skirts&Trousers-Cor/MainGallery.webp";

import { ReactComponent as GalleryIconAll } from "../../Assets/Svg/GalleryIconAll.svg";
import { ReactComponent as ScoolUniform } from "../../Assets/Svg/HomeS5P2Img2.svg";
import { ReactComponent as CorporateUniform } from "../../Assets/Svg/HomeS5P2Img9.svg";
import { ReactComponent as IndustrialUniform } from "../../Assets/Svg/HomeS5P2Img6.svg";
import { ReactComponent as HospitalityUniform } from "../../Assets/Svg/HomeS5P2Img13.svg";
// import { ReactComponent as MedicalUniform } from "../../Assets/Svg/HomeS5P2Img10.svg";
import { ReactComponent as CasualUniform } from "../../Assets/Svg/HomeS5P2Img11.svg";
import { ReactComponent as SportsUniform } from "../../Assets/Svg/HomeS5P2Img12.svg";
import "./GalleryS3.css";

const uniformCategories = [
  { id: "All", name: "ALL", arName: "كل المنتجات", icon: <GalleryIconAll /> },
  { id: "school_uniform", name: "EDUCATIONAL", arName: "التعليم", icon: <ScoolUniform /> },
  // { id: "medical", name: "MEDICAL", arName: "الطبي", icon: <MedicalUniform /> },
  { id: "casual", name: "CASUAL", arName: "كاجوال", icon: <CasualUniform /> },
  {
    id: "industrial",
    name: "INDUSTRIAL",
    arName: "الصناعة",
    icon: <IndustrialUniform />,
  },
  {
    id: "hospitality",
    name: "HOSPITALITY ",
    arName: "الضيافة",
    icon: <HospitalityUniform />,
  },
  { id: "sports", name: "SPORTS WEAR ", arName: "الرياضية", icon: <SportsUniform /> },
  { id: "corporate", name: "CORPORATE ", arName: "الشركات", icon: <CorporateUniform /> },
];

const uniformItems = {
  school_uniform: [
    {
      id: "WaistCoat School",
      name: "WaistCoat",
      arName: "صديري",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryWaistCoat,
      link: "/waistcoat",
    },
    {
      id: "Vests School",
      name: "Vests",
      arName: "سترات",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryVestsSchool,
      link: "/vests-schools",
    },
    {
      id: "Trousers Shorts School",
      name: (
        <>
          Trousers <br /> & Shorts
        </>
      ),
      arName: "بناطيل وسراويل قصيرة",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryTrousersShorts,
      link: "/trousers-shorts",
    },
    {
      id: "Sport Swear School",
      name: (
        <>
          Sport <br /> Swear
        </>
      ),
      arName: (
        <>
          ملابس <br /> رياضية
        </>
      ),
      backgroundImage: GalleryBgStatic,
      mainImage: GallerySportsWear,
      link: "/sports-wear",
    },
    {
      id: "Skirts Skorts School",
      name: (
        <>
          Skirts <br />& Skorts
        </>
      ),
      arName: "التنانير والتناينر القصيرة",
      backgroundImage: GalleryBgStatic,
      mainImage: GallerySkirtsSkorts,
      link: "/skirts-skorts",
    },
    {
      id: "Shirts School",
      name: "Shirts",
      arName: "قمصان",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryShirtsSchool,
      link: "/shirts-school",
    },
    {
      id: "Polos T-Shirts School",
      name: (
        <>
          Polos &<br /> T-Shirts
        </>
      ),
      arName: (
        <>
          تيشرتات <br /> بولو
        </>
      ),
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryPolosTShirts,
      link: "/polos-tshirts",
    },
    {
      id: "Pina Fores School",
      name: "Pinafores",
      arName: "مريولات",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryPinaFores,
      link: "/pinafores",
    },
    {
      id: "Jumper School",
      name: "Jumper",
      arName: (
        <>
          تيشرتات <br /> صوف
        </>
      ),
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryJumperSchool,
      link: "/jumper-school",
    },
    {
      id: "Graduation Gown School",
      name: "Graduation Gown",
      arName: "ثوب التخرج",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryGraduationGown,
      link: "/graduation-gown",
    },
    {
      id: "Cardigans School",
      name: "Cardigans",
      arName: (
        <>
          سترات <br /> صوفية
        </>
      ),
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryCardigansSchool,
      link: "/cardigans-school",
    },
    {
      id: "Blazers School",
      name: "Blazers",
      arName: "بلايزرات",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryBlazersSchool,
      link: "/blazers-school",
    },
  ],
  casual: [
    {
      id: "hoodies casual",
      name: (
        <>
          Hoody <br /> Sweat Shirt
        </>
      ),
      arName: "هودى",
      backgroundImage: GalleryBgStatic,
      mainImage: GallleryHoodySweatShirt,
      link: "/hoodysweatshirt",
    },
    {
      id: "JacketsVestCas",
      name: (
        <>
          Jackets <br />& Vest
        </>
      ),
      arName: "جاكيتات وسترات",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryJacketsVestCas,
      link: "/jacketsvestcas",
    },
    {
      id: "Polo casual",
      name: "Polo",
      arName: "بولو",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryPoloCasual,
      link: "/polocasual",
    },
    {
      id: "Cap casual",
      name: "Cap",
      arName: "قبعات",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryCapCasual,
      link: "/capcasual",
    },
  ],
  industrial: [
    {
      id: "VisibilitySuit industrial",
      name: (
        <>
          Visibility <br /> Suit
        </>
      ),
      arName: (
        <>
          بدلة عمل <br /> مع عواكس
        </>
      ),
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryVisibilitySuit,
      link: "/visibilitysuit",
    },
    {
      id: "VisibilityShirt industrial",
      name: "Visibility Shirt",
      arName: "قمصان مع عواكس",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryVisibilityShirt,
      link: "/visibilityshirt",
    },
    {
      id: "Visibility_Jacket industrial",
      name: "Visibility Jacket",
      arName: "جاكيتات عاكسة",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryVisibilityJacket,
      link: "/visibilityjacket",
    },
    {
      id: "VisibilityHiVisBib industrial",
      name: "Visibility Hi Vis Bib",
      arName: "مريولات عاكسة",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryVisibilityHiVisBib,
      link: "/visibilityhiVisbib",
    },
    {
      id: "VisibilityCoverall industrial",
      name: "Visibility Coverall",
      arName: "بدلات عمل كاملة عاكسة",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryVisibilityCoverall,
      link: "/visibilitycoverall",
    },
    {
      id: "IndustrialVest industrial",
      name: "Industrial Vest",
      arName: (
        <>
          سترات <br /> صناعية
        </>
      ),
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryIndustrialVest,
      link: "/industrialvest",
    },
    {
      id: "FireRetardantCoverall industrial",
      name: "Fire Retardant Coverall",
      arName: "بدلات مقاومة للحريق",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryFireRetardantCoverall,
      link: "/fireretardantcoverall",
    },
    {
      id: "Coverall industrial",
      name: "Coverall",
      arName: "بدلات عمل كاملة",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryCoverall,
      link: "/coverall",
    },
  ],
  hospitality: [
    {
      id: "aprons hospitality",
      name: "Aprons",
      arName: (
        <>
          مريولات <br /> طهاة
        </>
      ),
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryAprons,
      link: "/aprons",
    },
    {
      id: "chefCoat hospitality",
      name: "Chef Coat",
      arName: "معاطف الطهاة",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryChefCoat,
      link: "/chefcoat",
    },
    {
      id: "chefSuit hospitality",
      name: "Chef Suit",
      arName: (
        <>
          بدلات <br /> الطهاة
        </>
      ),
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryChefSuit,
      link: "/chefsuit",
    },
    {
      id: "chefHat hospitality",
      name: "Chef Hat",
      arName: (
        <>
          قبعات <br /> الطهاة
        </>
      ),
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryChefHat,
      link: "/chefhat",
    },
  ],
  sports: [
    {
      id: "outfit sports",
      name: "Outfit",
      arName: "ملابس رياضية كاملة",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryOutfitSport,
      link: "/outfitsport",
    },
    {
      id: "Tops-Bottoms-Sports",
      name: <>Tops & Bottoms</>,
      arName: "ملابس علوية وسفلية",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryTopsBottomsSport,
      link: "/topsbottomssport",
    },
  ],
  corporate: [
    {
      id: "Suits & Vests corporate",
      name: (
        <>
          Suits <br />& Vests
        </>
      ),
      arName: "بدلات وسترات",
      backgroundImage: GalleryBgStatic,
      mainImage: GallerySuitsVestsCor,
      link: "/suitsvestscor",
    },
    {
      id: "Security corporate",
      name: "Security",
      arName: "ملابس أمنية",
      backgroundImage: GalleryBgStatic,
      mainImage: GallerySecurityCor,
      link: "/securitycor",
    },
    {
      id: "Blouse & formal corporate",
      name: (
        <>
          Blouse <br />& formal shirts
        </>
      ),
      arName: "بلوزات وقمصان رسمية",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryBlouseFormalCor,
      link: "/blouseformalcor",
    },
    {
      id: "Dresses corporate",
      name: "Dresses",
      arName: "فساتين",
      backgroundImage: GalleryBgStatic,
      mainImage: GalleryDressesCor,
      link: "/dresses",
    },
    {
      id: "Skirts Trousers Cor",
      name: "Skirts & Trousers",
      arName: (
        <>
          تنانير <br /> وبناطيل
        </>
      ),
      backgroundImage: GalleryBgStatic,
      mainImage: GallerySkirtsTrousersCor,
      link: "/skirts-trousers",
    },
  ],
};
// sales@uniformarena.com
export default function GalleryS3Com() {
  const location = useLocation();
  const isArabic = location.pathname.endsWith("/ar");

  const defaultCategory = window.innerWidth < 768 ? "school_uniform" : "All";
  const passedCategory = location.state?.selectedCategory || defaultCategory;

  const [selectedCategory, setSelectedCategory] = useState(passedCategory);

  useEffect(() => {
    if (!location.state) {
      setSelectedCategory(defaultCategory);
    }
  }, [location.state, defaultCategory]);

  const handleCategoryClick = (categoryId) => {
    setSelectedCategory(categoryId);
  };

  const getItemsToDisplay = () => {
    if (selectedCategory === "All") {
      return Object.values(uniformItems).flat();
    } else {
      return uniformItems[selectedCategory] || [];
    }
  };

  const CategoryButton = ({ category, isSelected, onClick }) =>
    isArabic ? (
      <button className={`category-button ar ${isSelected ? "active" : ""}`} onClick={() => onClick(category.id)}>
        {category.icon && <span className="icon ar">{category.icon}</span>}
        {category.arName}
      </button>
    ) : (
      <button className={`category-button ${isSelected ? "active" : ""}`} onClick={() => onClick(category.id)}>
        {category.icon && <span className="icon">{category.icon}</span>}
        {category.name}
      </button>
    );

  return (
    <>
      {/*  */}
      {isArabic ? (
        <div className="GalleryS3">
          <div className="categories" dir="rtl">
            {uniformCategories.map((category) => (
              <CategoryButton key={category.id} category={category} isSelected={selectedCategory === category.id} onClick={handleCategoryClick} />
            ))}
          </div>
          <div className="uniform-items" dir="rtl">
            {getItemsToDisplay().map((item) => (
              <Link key={item.id} to={`${item.link}/ar`} className="uniform-item-link">
                <div className="uniform-item">
                  <div className="uniform-item-background ar" style={{ backgroundImage: `url(${item.backgroundImage})` }}>
                    <div className="uniform-item-name ar">{item.arName}</div>
                    <Link to={`${item.link}/ar`} className="view-details-button ar">
                      انقر للعرض
                    </Link>
                  </div>
                  <img
                    src={item.mainImage}
                    alt={item.name}
                    className="uniform-item-main-image ar"
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = "path-to-fallback-image.jpg";
                    }}
                  />
                </div>
              </Link>
            ))}
          </div>
        </div>
      ) : (
        <div className="GalleryS3">
          <div className="categories">
            {uniformCategories.map((category) => (
              <CategoryButton key={category.id} category={category} isSelected={selectedCategory === category.id} onClick={handleCategoryClick} />
            ))}
          </div>
          <div className="uniform-items">
            {getItemsToDisplay().map((item) => (
              <Link key={item.id} to={item.link} className="uniform-item-link">
                <div className="uniform-item">
                  <div className="uniform-item-background" style={{ backgroundImage: `url(${item.backgroundImage})` }}>
                    <div className="uniform-item-name">{item.name}</div>
                    <Link to={item.link} className="view-details-button">
                      Click To View
                    </Link>
                  </div>
                  <img
                    src={item.mainImage}
                    alt={item.name}
                    className="uniform-item-main-image"
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = "path-to-fallback-image.jpg";
                    }}
                  />
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
